import {Component, OnInit} from '@angular/core';
import {SalesCreditSummaryKredicashComponent} from '../sales-credit-summary-kredicash.component';

@Component({
  selector: 'app-sales-credit-summary-kredicash-v2',
  templateUrl: './sales-credit-summary-kredicash-v2.component.html'
})
export class SalesCreditSummaryKredicashV2Component extends SalesCreditSummaryKredicashComponent implements OnInit {
  override ngOnInit() {
    this.getRequest();
    this.requestService.step.set(5);
  }
}

@Component({
  selector: 'app-sales-credit-summary-kredicash-v3',
  templateUrl: './sales-credit-summary-kredicash-v3.component.html',
})
export class SalesCreditSummaryKredicashV3Component extends SalesCreditSummaryKredicashComponent implements OnInit {
  override ngOnInit() {
    this.getRequest();
    this.requestService.step.set(5);
  }
}
